import { Grid, Typography } from "@mui/material";
import React from "react";
import theme from "../../theme";
import { Link } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const AddPromotionsForm = () => {
  return (
    <Grid display={"flex"} flexDirection={"column"}>
      <Grid sx={{ background: theme.color?.background }} px={4}>
        <Grid
          item
          display={"flex"}
          alignItems={"center"}
          height={"15vh"}
          gap={2}
        >
          <Link to={"/promotions"}>
            <ArrowBackIosIcon />
          </Link>
          <Grid item display={"flex"} alignItems={"center"} maxWidth={"25%"}>
            <Typography
              variant="h6"
              sx={{
                color: theme?.color?.primary,
                fontWeight: "600",
                fontFamily: theme.font?.fontFamily.primary,
                textTransform: "capitalize",
              }}
            >
              Add Promotions
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AddPromotionsForm;
